import HTTPServices from "../HTTPServices/httpService";

const smsService = {
  //(1)
  getSMSBalance: async function () {
    console.log("'getSMSBalance' service called");
    let result = await HTTPServices.get("sms/getsmsbalance");
    // debugger;
    console.log("SMS Balance result --->" + JSON.stringify(result));
    return result;
  },
};

export default smsService;
